import type { ReactNode } from "react";
import styles from "./KeyValueList.module.css";

/** Ruhige Liste von Angaben (Bestätigung, Ergebnis). `ltr` für Kennungen wie KVNR/IK. */
export function KeyValueList({
  items,
}: {
  items: Array<{ key: string; label: ReactNode; value: ReactNode; ltr?: boolean }>;
}) {
  return (
    <dl className={styles.list}>
      {items.map((i) => (
        <div key={i.key} className={styles.row}>
          <dt className={styles.label}>{i.label}</dt>
          <dd className={styles.value}>
            {i.ltr ? (
              <bdi dir="ltr" className={styles.mono}>
                {i.value}
              </bdi>
            ) : (
              i.value
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
